/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import tourService from '../services/tour.service';

const sharedMethods = {
  data() {
    return {
      tourCallbacks: {
        onStart: tourService.onStart,
        onNextStep: tourService.onNext,
        onPreviousStep: tourService.onPrevious,
        onStop: tourService.onStop,
      },
    };
  },
};
export default sharedMethods;
